// extracted by mini-css-extract-plugin
export var headline = "pages-headline-ot-Q2";